/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MapZoneDto } from './mapZoneDto';

export interface MapStatisticsDto {
  maxValue?: number;
  minValue?: number;
  parameter?: Array<string>;
  points?: number;
  unit?: string;
  zones?: Array<MapZoneDto>;
}
